// extracted by mini-css-extract-plugin
export var accent = "_bh-4";
export var add = "_bh-j";
export var addIcon = "_bh-k";
export var deleteIcon = "_bh-i";
export var disabled = "_bh-9";
export var ellipsis = "_bh-f";
export var error = "_bh-3";
export var form = "_bh-5";
export var hideFocus = "_bh-2";
export var icon = "_bh-7";
export var input = "_bh-e";
export var listItem = "_bh-h";
export var mediumHeight = "_bh-b";
export var noBorder = "_bh-8";
export var noRadius = "_bh-1";
export var shortHeight = "_bh-a";
export var tallHeight = "_bh-c";
export var textInput = "_bh-0";
export var vertical = "_bh-g";
export var veryTallHeight = "_bh-d";
export var widget = "_bh-6";